<template>
    <a href="https://cacertappliances.energy.ca.gov/Pages/ApplianceSearch.aspx"  target="_blank" class="btn database-of-devices-btn btn-default">Database List.</a>
</template>
<script>
    export default { }
</script>
